import { WHATSAPP } from '@app/constants/socialIntegrationsTypes';

const WHATSAPP_BOLD_PATTERN = /\*(.*?)\*/g;

export const formatLeadMessageText = (
  text: string,
  socialType: string | null
): string => {
  if (socialType === WHATSAPP) {
    return text.replace(WHATSAPP_BOLD_PATTERN, '<b>$1</b>');
  }
  return text;
};
